import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import Logo2 from './assets/Logo2.png';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  // Fail fast — the previous Logto setup did the same. Silent fallbacks
  // hid configuration bugs in CI before.
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required (set in .env.local for dev or Vercel env vars for prod).');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={publishableKey}
      // Same Clerk instance as the Student app, but Platform-Admin owns its
      // own sign-in URL and intentionally has no sign-up surface (admins are
      // provisioned manually in the Clerk Dashboard with public_metadata.role
      // set to "ADMIN", which the API's session-token guard reads on first
      // sign-in to JIT-create the User row with the right role).
      signInUrl="/signin"
      signInFallbackRedirectUrl="/manage-schools"
      afterSignOutUrl="/signin"
      // Instance-wide branding — see the matching note in School-Admin.
      // Clerk surfaces beyond <SignIn> (user button, verification modals)
      // otherwise fall back to the pre-rebrand logo on the Clerk instance.
      appearance={{ layout: { logoImageUrl: Logo2, logoLinkUrl: '/manage-schools' } }}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
